export default __webpack_public_path__ + "static/media/99776312_s.d565f2d8.jpg";